import { useState } from 'react';

// Import constants
import { DEVICE_ID_KEY } from '../../constants/schedule';

// Import utils
import { logger } from '../../utils/logger';

/**
 * Provides a deviceId to feed into the participant state.
 * - Initializes from localStorage on the first render for immediate availability.
 * - Updates when a persisted deviceId (e.g., from useRoomPersistence) becomes available.
 */
export default function useParticipantsDeviceId(): [
  string,
  (id: string) => void,
] {
  const [participantsDeviceId, setParticipantsDeviceId] = useState<string>(
    () => {
      try {
        return localStorage.getItem(DEVICE_ID_KEY) || '';
      } catch (e: unknown) {
        logger.error('Failed to read localStorage', e);
        return '';
      }
    },
  );

  return [participantsDeviceId, setParticipantsDeviceId];
}
